
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getTaskList, userTaskExport } from '@/api/statistics';
import { UserModule } from '../../store/modules/user';

const taskStatusOptions = [
  {
    value: '2',
    label: '未处理'
  },
  {
    value: '3',
    label: '进行中'
  },
  {
    value: '4',
    label: '已完成'
  }
];

const modeOptions = [
  {
    value: '5',
    label: '送修'
  },
  {
    value: '1',
    label: '远程'
  },
  {
    value: '2',
    label: '上门'
  },
  {
    value: '3',
    label: '寄修'
  },
  {
    value: '4',
    label: '转派'
  },
  {
    value: '6',
    label: '其他'
  },
  {
    value: '9',
    label: '接单即处理'
  }
];

@Component({
  name: 'StatisticsStaffTask',
  components: {
  }
})
export default class extends Vue {
  private formSearch = {
    timePeriods: '',
    task_state: '',
    deal_type: ''
  };

  private taskStatusOptions = taskStatusOptions;
  private modeOptions = modeOptions;

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private loading = false;
  private tableData = [];

  // 导出Excel
  handleExport() {
    let orderParams: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      engineer_id: this.user.user_id,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName
    };
    if (
      this.formSearch.timePeriods &&
      this.formSearch.timePeriods.length === 2
    ) {
      orderParams.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      orderParams.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    if (this.formSearch.task_state) {
      orderParams.task_state = this.formSearch.task_state;
    }
    if (this.formSearch.deal_type) {
      orderParams.deal_type = this.formSearch.deal_type;
    }
    userTaskExport(orderParams)
      .then((res) => {
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private user: any = {};
  created() {
    this.user = JSON.parse(this.$route.query.user as string);
    this.getList();
  }

  private getList() {
    let orderParams: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      engineer_id: this.user.user_id,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    if (
      this.formSearch.timePeriods &&
      this.formSearch.timePeriods.length === 2
    ) {
      orderParams.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      orderParams.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    if (this.formSearch.task_state) {
      orderParams.task_state = this.formSearch.task_state;
    }
    if (this.formSearch.deal_type) {
      orderParams.deal_type = this.formSearch.deal_type;
    }

    this.loading = true;
    getTaskList(orderParams)
      .then((res) => {
        if (res && res.data) {
          this.pagination.total = parseInt(res.data.count);
          this.tableData = res.data.list;
        } else {
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.loading = false;
      })
      .catch((err) => {
        if (!err.data) {
          this.tableData = [];
          this.loading = false;
        }
      });
  }
  handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  handleClear() {
    this.formSearch = {
      timePeriods: '',
      task_state: '',
      deal_type: ''
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }
  // 订单详情
  detailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: '/Task/todetail',
      query: {
        'taskId': val.order_task.id,
        'companyId': val.order_task.company_id,
        'orderType': val.order.order_type,
        'enterType': '1',
        'isDetail': '1',
      },
    });
    window.open(routeData.href);
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
